import React from 'react';
import PropTypes from 'prop-types';
import MainGridTopLeft from './MainGridTopLeft';
import MainGridTopRightDayOffTypePachi from './MainGridTopRightDayOffTypePachi';
import MainGridMiddleLeftDayOffTypePachi from './MainGridMiddleLeftDayOffTypePachi';
import MainGridMiddleRightDayOffTypePachi from './MainGridMiddleRightDayOffTypePachi';

/**
 * MainGrid1
 */
class MainGrid1 extends React.Component {

  componentDidMount() {
    $('#ledger_sheet_01').flexLedgerSheet();
    $('#ledger_sheet_01').bindClickTriggerContextMenu();
  }

  componentDidUpdate() {
    if (this.props.data.offset != 1 && this.props.data.scrollEnd == false) {
      $('#ledger_sheet_01').flexLedgerSheetScrollDown();
      $('#ledger_sheet_01').bindClickTriggerContextMenu();
    }
  }

  render() {
    const pskubun = this.props.data.pskubun;
    const kikanUnit = this.props.data.kikanUnit;
    const term = this.props.data.term;
    const toK015Param = {
      pskubun: pskubun,
      kikanUnit: kikanUnit,
      term: term
    }
    
    return (
      <div id="ledger_sheet_01" className="wrap_ledger_sheet limit_col_width grid1">
        <div className="ledger_sheet_top grid_sheet_top">
          <MainGridTopLeft />
          <MainGridTopRightDayOffTypePachi actions={this.props.actions} sortKey={this.props.data.sortKey} sortOrder={this.props.data.sortOrder} dayFlg={this.props.data.dayFlg} usedMachinePriceDataUpdateFlag={this.props.data.usedMachinePriceDataUpdateFlag} />
        </div>
        <div className="ledger_sheet_middle grid_line_bottom">
          <MainGridMiddleLeftDayOffTypePachi dataDayOff={this.props.data.dataPachi} toK015Param={toK015Param} actions={this.props.actions} scrollTop={this.props.data.scrollTop} />
          <MainGridMiddleRightDayOffTypePachi dataDayOff={this.props.data.dataPachi} actions={this.props.actions} />
        </div>
      </div>
    );
  }
}

MainGrid1.propTypes = {
  data: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired
};

export default MainGrid1;
